import { Card } from '@mui/material'
import Grid from '@mui/material/Grid'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import Loader from 'examples/Loader'
import CustomDataTable from '../Users/CustomDataTable'
import FilterBar from './components/FilterBar'
import NotificationFormModal from './components/NotificationFormModal'
import AppData from './components/data-tables/data/dataTableData'

function SiteNotifications() {
  const {
    dataTableData,
    loader,
    filters,
    setFilters,
    pagination,
    handleRefresh,
    handlePageChange,
    handleLimitChange,
  } = AppData()

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Website Notifications
                </MDTypography>
                <NotificationFormModal handleRefresh={handleRefresh} />
              </MDBox>

              <MDBox pt={3} px={3}>
                <FilterBar
                  filters={filters}
                  onChange={setFilters}
                  onRefresh={handleRefresh}
                  total={pagination.totalUsers}
                />
              </MDBox>

              <MDBox pt={2} px={3}>
                {loader ? (
                  <Loader />
                ) : (
                  <CustomDataTable
                    table={dataTableData}
                    canSearch={false}
                    entriesPerPage={{
                      defaultValue: pagination?.limit || 20,
                      entries: [10, 20, 50, 100],
                    }}
                    pagination={pagination}
                    onPageChange={handlePageChange}
                    onLimitChange={handleLimitChange}
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  )
}

export default SiteNotifications
